module.exports = __webpack_public_path__ + "static/media/26UNRWA14.4fa91cb8.jpg";